import "../../styles/Offerings/Offering.css";
import OfferringBanner from "../../components/OfferingsComponents/OfferringBanner";
import OfferringPlan from "../../components/OfferingsComponents/OfferringPlan";
import Offer from "../../components/OfferingsComponents/Offer";
import Dream from "../../components/OfferingsComponents/Dream";
import OfferingService from "../../components/OfferingsComponents/OfferingService";
import WhyChooseLovenCoders from "../../components/OfferingsComponents/WhyChooseLovenCoders";
import { useMediaQuery } from "react-responsive";
import MobileOfferringPlan from "../../components/OfferingsComponents/Mobile/MobileOfferringPlan";
const Offerings = () => {
  const offerData = {
    title: "Special Offer",
    discount: "25% Off",
    year: "2025",
    description:
      "We offer tailored plans to guide startups at every stage—whether you're refining an idea, overcoming early-stage struggles, or scaling fast. Select the plan that best fits your journey and start building today!",
  };

  const whyData = {
    title: "Why Choose LovenCoders?",
    description:
      "We’re proud to have made a significant impact on the global startup ecosystem. Explore our achievements on our Live Public Dashboard",
    whyOptions: [
      {
        title: "Tailored Solutions For Every Stage",
        description:
          "Whether you're at the Idea, Valley, or Growth stage, we provide expert guidance to help you succeed.",
      },
      {
        title: "Exclusive Perks",
        description:
          "Get free eBooks, discounts, and insights from elite startup mentors.",
      },
      {
        title: "Results-Driven Approach",
        description:
          "We focus on practical execution, ensuring real startup growth.",
      },
    ],
  };
  const isDesktop = useMediaQuery({ minWidth: 786 });
  return (
    <div className="offering-container">
      <OfferringBanner />
      <Offer offerData={offerData} />
      {isDesktop && <OfferringPlan />}
      {!isDesktop && <MobileOfferringPlan />}
      <OfferingService />
      <WhyChooseLovenCoders whyData={whyData} />
      <Dream />
    </div>
  );
};

export default Offerings;
